import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { EmptyState } from '@components/Feed/ListViews/components/EmptyState';
import { FeedListSkeleton } from '@components/Feed/ListViews/components/Skeleton';
import { ProfileFeedHeader } from '@components/Feed/ProfileFeedHeader';
import type { FragmentType, SeeAllUserInfoFragmentDoc } from '@graphql/reactQuery';
import { CollectorActivityFeedDocument, useQuery } from '@graphql/reactQuery';
import { ActionComponent } from '../CarouselsExpanded/CollectorActivity/CollectorActivity';
import { PROFILE_MAX_ACTIVITY_ITEMS, RecentActivityContainer } from '../shared';
import { SubContainer } from '../styles';

export function CollectorRecentActivity({
  user: userFrag,
  userId,
}: {
  user: FragmentType<SeeAllUserInfoFragmentDoc>;
  userId: string;
}) {
  const { data: activityData, isLoading: loading } = useQuery(CollectorActivityFeedDocument, {
    variables: {
      userId,
      pagination: { first: PROFILE_MAX_ACTIVITY_ITEMS },
    },
    staleTime: 0,
  });

  return (
    <RecentActivityContainer>
      <CollectorTopSubContainer>
        <ProfileFeedHeader
          user={userFrag}
          showSeeAll={activityData?.data.collectorActivityFeed?.pageInfo.hasNextPage ?? false}
        />
      </CollectorTopSubContainer>

      <CollectorSecondarySubContainer>
        {loading ? (
          <FeedListSkeleton rows={5} />
        ) : (
          activityData?.data.collectorActivityFeed?.edges.map(edge => (
            <ActionComponent key={edge.node.id} item={edge.node} />
          ))
        )}
        {activityData?.data.collectorActivityFeed?.edges.length === 0 && <EmptyState />}
      </CollectorSecondarySubContainer>
    </RecentActivityContainer>
  );
}

const CollectorTopSubContainer = styled(SubContainer, {
  paddingBottom: 12,
  '@tabletLandscape': {
    paddingBottom: 24,
  },
});

const CollectorSecondarySubContainer = styled(SubContainer, {
  gap: 0,
});
